import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
    CRUD_DELETE_MANY_SUCCESS
} from 'store/actions/dataActions';

export const makeNotificationMessage = (type, message, requestMsgArgs, responseMsgArgs) => {

    switch(type) {
        case CRUD_DELETE_MANY_SUCCESS:
            return <FormattedMessage id={ message }
                     values={{ cnt: responseMsgArgs.successCount ? responseMsgArgs.successCount : 0}} />

        default:
            return <FormattedMessage id={message} />;
    }
}
